import { Col, Row, Card } from 'react-bootstrap';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

import TimeSeriesLineChart from '../components/TimeSeriesLineChart.jsx';
import ChartCard from '../components/ChartCard.jsx';
import TideCard from '../components/TideCard.jsx';
import AdCard from '../components/AdCard.jsx';
import { getSiteData, getSiteDataSourcesForTypes, getSiteDataSubset } from '../helpers/SiteData.js';
import { SITE_TYPE_TIDE, SITE_TYPE_TIDE_FORECAST } from '../helpers/SiteDataConst.js';

function TideSiteBlock({site, allData}) {
  const {t} = useTranslation();
  const data = getSiteData(allData, site.id, SITE_TYPE_TIDE);
  const forecastData = getSiteData(allData, site.id, SITE_TYPE_TIDE_FORECAST);

  return (
    <div key={site.id}>
      <h3>{site.name}</h3>
      <Row>
        <Col xs={12} md={6} lg={7} xl={8} className={'mb-4'}>
          <ChartCard
            title={`Tide Height (${t(`units.${site.properties.unit}.label`)})`}
            time={data?.[0]?.timestamp}
            dataSource={getSiteDataSourcesForTypes(site, [SITE_TYPE_TIDE, SITE_TYPE_TIDE_FORECAST])}
          >
            <TimeSeriesLineChart
              data={data != undefined && forecastData != undefined ? [data, forecastData] : undefined}
              curve={'natural'}
              minDate={DateTime.now().minus({ days: 3 }).toJSDate()}
              maxDate={DateTime.now().plus({ days: 1 }).toJSDate()}
              dataSeries={[SITE_TYPE_TIDE, SITE_TYPE_TIDE_FORECAST]}
              title={site.name}
              unit={t(`units.${site.properties.unit}.label`)}
              margin={{ top: 20, right: 40, bottom: 60, left: 40 }}
              zeroPoint={0}
            />
          </ChartCard>
          <AdCard />
        </Col>
        <Col xs={12} md={6} lg={5} xl={4} className={'mb-4'}>
          <TideCard
            title="Predicted Tides"
            dataSource={getSiteDataSourcesForTypes(site, [SITE_TYPE_TIDE_FORECAST])}
            tideForecastData={getSiteDataSubset(
              forecastData,
              DateTime.now().minus({ hours: 12 }).startOf('day'),
              DateTime.now().plus({ days: 3 }).endOf('day')
            )}
            units={t(`units.${site.properties.unit}.label_short`)}
          />
        </Col>
      </Row>
    </div>
  );
}

export default TideSiteBlock;
